import type { ExposureMode, TenantHealth, TenantStatus } from '@teachpartner/contracts';

/** E2E vs Cloudflare tunnel (brief §3.1: tunnel tenants are flagged as not end-to-end). */
export function ExposureBadge({ mode }: { mode: ExposureMode }) {
  return mode === 'passthrough' ? (
    <span className="badge badge-ok" title="TLS ends on the school server (SNI passthrough)">
      E2E encrypted
    </span>
  ) : (
    <span
      className="badge badge-warn"
      title="Cloudflare decrypts traffic at its edge before it reaches the school"
    >
      Cloudflare tunnel — not end-to-end encrypted
    </span>
  );
}

const STATUS_CLASS: Record<TenantStatus, string> = {
  active: 'badge-ok',
  maintenance: 'badge-info',
  suspended: 'badge-warn',
  disabled: 'badge-muted',
};

export function StatusBadge({ status }: { status: TenantStatus }) {
  return <span className={`badge ${STATUS_CLASS[status]}`}>{status}</span>;
}

export function HealthIndicator({ health }: { health: TenantHealth | null }) {
  if (!health) return <span className="badge badge-muted">not checked</span>;
  return health.ok ? (
    <span className="badge badge-ok" title={`Checked ${health.checkedAt}`}>
      healthy
    </span>
  ) : (
    <span className="badge badge-error" title={health.error ?? 'Unhealthy'}>
      unhealthy
    </span>
  );
}

export function ErrorBanner({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <div role="alert" className="banner banner-error">
      {message}
    </div>
  );
}
